import { Button, Flex, Form, FormInstance, Modal } from 'antd';
import FranchisorsForm from '../form';
import { useEffect } from 'react';

interface Props {
  open: boolean;
  onCancel: () => void;
  handleFinish: (values: any) => void;
  loading: boolean;
  childFormInstance?: (form: FormInstance) => void;
}

export default function CreateUserModal({
  open,
  onCancel,
  handleFinish,
  loading,
  childFormInstance,
}: Props): JSX.Element {
  const [form] = Form.useForm();

  const handleClose = () => {
    form.resetFields();
    onCancel();
  };

  useEffect(() => {
    if (childFormInstance) {
      childFormInstance(form);
    }
  }, [form, childFormInstance]);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [form, open]);

  return (
    <Modal
      title={'Create User'}
      open={open}
      onCancel={handleClose}
      footer={null}
      width={460}
      centered
    >
      <FranchisorsForm handleFinish={handleFinish} form={form} />
      <Flex gap={12}>
        <Button
          onClick={() => form.submit()}
          type={'primary'}
          className={'admin-button-download-table'}
          style={{
            paddingInline: '32px',
          }}
          disabled={loading}
        >
          Create & Get Activation Link
        </Button>

        <Button
          type={'default'}
          onClick={handleClose}
          style={{
            backgroundColor: 'white',
            color: '#1C8271',
            boxShadow: 'none',
            width: '100%',
            height: '40px',
            paddingInline: '32px',
          }}
        >
          Cancel
        </Button>
      </Flex>
    </Modal>
  );
}
